/**
 * impleco contact form
 * https://impleco.atlassian.net/browse/WISCH-70
 */

import React, { useEffect, useState } from 'react';
import Config from '../../utils/Config';
import RequestManager from '../../utils/RequestManager';
import createToast from '../MaterialUi/Toast';
import ContactThemeProvider from './ContactThemeProvider';
import Expertenrat from './Expertenrat';
import Kontakt from './Kontakt';
import Kooperationsanfrage from './Kooperationsanfrage';
import NewsletterRapidmail from './NewsletterRapidmail';
import LogError from '../../utils/LogError';

const BASE_URL = Config.get('baseUrl').replace(/\/$/, ''); // without trailing slash

export interface IContactFormProps {
    variant: 'kontakt' | 'expertenrat' | 'newsletter' | 'kooperationsanfrage'
}

export interface IConcreteContactFormProps {
    onSubmit: (formValues: any) => Promise<void>
}

const ContactForm: React.FC<React.PropsWithChildren<IContactFormProps>> = ({ variant }) => {


    const handleSubmit = (formValues: any) => {
        // const url = `http://wohnglueck.local.computer/wgl-api/forms/${encodeURIComponent(variant)}/submit`
        const url = `${BASE_URL}/wgl-api/forms/${encodeURIComponent(variant)}/submit`
        return RequestManager.postRequest(url, {}, formValues).then(res => {
            const message = res.getData()?.message;
            createToast(message || 'Die Anfrage wurde verschickt.', "success");
        }).catch(e => {
            console.error(e);
            createToast('Ein Fehler ist aufgetreten!', 'error');
            LogError.add(e, {
                title: 'Fehler beim Versenden des Kontakt-Formulars!',
                error_code: 'ContactForm.tsx:handleSubmit',
                request_data: { url, formValues }
            });
            return Promise.reject(e);
        }
        )
        console.log(`Submit Form: ${variant}`, formValues)
    }

    switch (variant) {
        case 'kontakt':
            return <ContactThemeProvider><Kontakt onSubmit={handleSubmit} /></ContactThemeProvider>
        case 'expertenrat':
            return <ContactThemeProvider><Expertenrat onSubmit={handleSubmit} /></ContactThemeProvider>
        case 'kooperationsanfrage':
            return <ContactThemeProvider><Kooperationsanfrage onSubmit={handleSubmit} /></ContactThemeProvider>
        case 'newsletter':
            return <ContactThemeProvider><NewsletterRapidmail /></ContactThemeProvider>
    }

    return <b>Form Variant not found: {variant}</b>

};

export default ContactForm;
